<button [type]="type()" [disabled]="disabled()" style="display:flex;align-items: center;max-height: 52px;">
  <ng-content />
</button>
